/** Bar size limits for OI Profile — kept separate from oiProfile.ts to avoid circular imports via util/chart. */

import { getDefaultMultiStrikeColorPalette } from '../../../multiStikeChart/multiStrikeColorPalettes'

/** Standard call/put: theme + multi-strike OI (#2F2FCD / #FFA719). */
const oiProfileDefaultPalette = getDefaultMultiStrikeColorPalette('light')

export const OI_PROFILE_DEFAULT_PRIMARY_CALL_COLOR = oiProfileDefaultPalette.callCumulative
export const OI_PROFILE_DEFAULT_SECONDARY_CALL_COLOR = oiProfileDefaultPalette.callColors[1]
export const OI_PROFILE_DEFAULT_PRIMARY_PUT_COLOR = oiProfileDefaultPalette.putCumulative
export const OI_PROFILE_DEFAULT_SECONDARY_PUT_COLOR = oiProfileDefaultPalette.putColors[1]

export type OiProfileColorSettingKey =
    | 'primaryCallColor'
    | 'secondaryCallColor'
    | 'primaryPutColor'
    | 'secondaryPutColor'

const OI_PROFILE_COLOR_DEFAULTS: Record<OiProfileColorSettingKey, string> = {
    primaryCallColor: OI_PROFILE_DEFAULT_PRIMARY_CALL_COLOR,
    secondaryCallColor: OI_PROFILE_DEFAULT_SECONDARY_CALL_COLOR,
    primaryPutColor: OI_PROFILE_DEFAULT_PRIMARY_PUT_COLOR,
    secondaryPutColor: OI_PROFILE_DEFAULT_SECONDARY_PUT_COLOR,
}

/** Fallback when script/layout omits a color key; otherwise backend script settings win. */
export const resolveOiProfileColor = (key: OiProfileColorSettingKey, stored?: string | null): string => {
    if (!stored) {
        return OI_PROFILE_COLOR_DEFAULTS[key]
    }
    return stored
}

export const OI_PROFILE_MIN_BAR_THICKNESS = 5
export const OI_PROFILE_MAX_BAR_THICKNESS = 20
export const OI_PROFILE_DEFAULT_BAR_THICKNESS = 10
export const OI_PROFILE_MIN_BAR_WIDTH_PERCENT = 10
export const OI_PROFILE_MAX_BAR_WIDTH_PERCENT = 50
export const OI_PROFILE_DEFAULT_BAR_WIDTH_PERCENT = 25

export const clampOiProfileBarThickness = (value: number) =>
    Math.min(OI_PROFILE_MAX_BAR_THICKNESS, Math.max(OI_PROFILE_MIN_BAR_THICKNESS, value))

export const clampOiProfileBarWidthPercent = (value: number) =>
    Math.min(OI_PROFILE_MAX_BAR_WIDTH_PERCENT, Math.max(OI_PROFILE_MIN_BAR_WIDTH_PERCENT, value))
